import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, IconButton, Typography } from '@mui/material';
import React from 'react';

interface IMappingsRowProps {
	leftComponent: React.ReactNode;
	rightComponent: React.ReactNode;
	onDelete: () => void;
	disabled?: boolean;
	label?: string | undefined;
}

const MappingsRow: React.FC<IMappingsRowProps> = ({
	onDelete,
	leftComponent,
	rightComponent,
	disabled,
	label
}) => (
	<Grid container alignItems="center" spacing={2} data-testid="mappings-row">
		<Grid item xs={11} sm>
			{leftComponent}
		</Grid>
		{label && (
			<Grid item xs="auto" textAlign={{ xs: 'left', lg: 'center' }}>
				<Typography variant="body2">{label}</Typography>
			</Grid>
		)}
		<Grid item xs={11} sm>
			{rightComponent}
		</Grid>
		{!disabled && (
			<Grid item xs="auto" mr={1}>
				<IconButton
					onClick={onDelete}
					aria-label={intl.tr('button.delete')}
					data-testid="mappings-delete-button"
				>
					<DeleteIcon />
				</IconButton>
			</Grid>
		)}
	</Grid>
);

MappingsRow.defaultProps = {
	disabled: false,
	label: undefined
};

export default MappingsRow;
